import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createElement as _createElement } from "react";
import React, { Fragment } from "react";
import { useMessages, useTranslations } from "next-intl";
import { useDocumentUrls } from "./hooks/useDocumentUrls";
var metaKey = function(param, index) {
    var charSet = param.charSet, content = param.content, httpEquiv = param.httpEquiv, name = param.name, property = param.property;
    if (charSet) {
        return charSet;
    }
    if (name && content) {
        return "".concat(name, "-").concat(content);
    }
    if (property && content) {
        return "".concat(property, "-").concat(content);
    }
    if (httpEquiv && content) {
        return "".concat(httpEquiv, "-").concat(content);
    }
    return "".concat(index);
};
var Head = function(param) {
    var document = param.document, HeadComponent = param.headComponent;
    var ref = useDocumentUrls(), canonicalUrl = ref.canonicalUrl, hreflangUrls = ref.hreflangUrls;
    var title = (document === null || document === void 0 ? void 0 : document.title) || "";
    var messages = useMessages();
    var _documentLegacy = messages.features.documentLegacy, links = _documentLegacy.links, metaItems = _documentLegacy.meta;
    var linkTranslations = useTranslations("features.documentLegacy.links");
    var metaTranslations = useTranslations("features.documentLegacy.meta");
    return /*#__PURE__*/ _jsxs(HeadComponent, {
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: title
            }),
            /*#__PURE__*/ _jsx("meta", {
                property: "og:title",
                content: title
            }),
            Object.keys(metaItems).map(function(item, index) {
                var meta = metaTranslations.raw(item);
                return /*#__PURE__*/ _jsxs(Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("meta", _object_spread({}, meta)),
                        meta.name === "description" && /*#__PURE__*/ _jsx("meta", {
                            property: "og:description",
                            content: meta.content
                        })
                    ]
                }, metaKey(meta, index));
            }),
            document === null || document === void 0 ? void 0 : document.meta.map(function(meta) {
                return /*#__PURE__*/ _jsxs(Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("meta", _object_spread({}, meta)),
                        meta.name === "description" && /*#__PURE__*/ _jsx("meta", {
                            property: "og:description",
                            content: meta.content
                        })
                    ]
                }, meta.name);
            }),
            Object.keys(links).map(function(link) {
                var linkData = linkTranslations.raw(link);
                return /*#__PURE__*/ _createElement("link", _object_spread_props(_object_spread({}, linkData), {
                    key: linkData.href
                }));
            }),
            hreflangUrls.map(function(hreflangUrl) {
                return /*#__PURE__*/ _createElement("link", _object_spread_props(_object_spread({}, hreflangUrl), {
                    key: hreflangUrl.href
                }));
            }),
            /*#__PURE__*/ _jsx("link", _object_spread({}, canonicalUrl))
        ]
    });
};
export { Head };
